<template>
  <div class='portfoliowork'>
    
    <nav>
      <div class="nav-left">
        <span class="current"><router-link :to="{ name: 'Portfolio', params: { categoria:projectos[0].categoria}}">Portfolio</router-link></span>
        <span class="separador">&nbsp;</span>
        <span class="sub active"><router-link :to="{ name: 'Portfolio', params: { categoria:projectos[0].categoria}}">{{ projectos[0].categoria }}</router-link></span>
        <span class="separador">&nbsp;</span>
        <span class="sub"> {{ projectos[0].titulo }} </span>
      </div>
      <div class="nav-right">
        <router-link to="/atelier">Atelier </router-link>
        <span class="separador">&nbsp;</span>
        <router-link to="/registos">Registos </router-link>
        <span class="separador">&nbsp;</span>
        <router-link to="/contactos">Contactos</router-link>
      </div>
    </nav>

    <main class="portfoliowork-content">
        <div class="portfoliowork-slide" v-for="projecto in projectos" :key="projecto.id">
            <img class="portfoliowork-img" :src="'http://atelieradaoparanhos.com' + projecto.destaque">
            <div class="portfoliowork-desc" v-html="projecto.descricao">
            </div>
        </div>
    </main>

  </div>

</template>

<script>

import { Carousel, Slide } from 'vue-carousel'
import axios from 'axios'
import VueAxios from 'vue-axios'

export default {
  name: 'PortfolioWork',
  data () {
    return {
      filter: 'editorial',
      projectos: [
      ]
    }
  },
  components: {
    Carousel,
    Slide
  },
  methods: {
    setFilter: function (newFilter) {
      this.filter = newFilter
    },
    filterIsActive: function (currentFilter) {
      return this.filter === currentFilter
    },
    loadPortfolio: function () {
      var app = this
      axios.get('/admin/api/portfolio/' + this.$route.params.uid).then((response) => {
        app.projectos = response.data
      })
    }
  },
  mounted: function () {
    this.loadPortfolio()
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang='scss'>


.portfoliowork {
  height: 100%;
  
  .nav-left span.sub {
    cursor: default;
  }
  
  &-content {
    max-width: 1920px;
    width: 100%;
    margin: 0 auto;
    display: flex;
    padding: 0 10px;
  }

  &-slide {
    margin: 0 2px;
    &:nth-child(1) {
      display: none;
    }

    &:nth-child(3) {
      .portfoliowork-desc {
        display: block;
      }
    }

  }

  &-img {
    height: auto;
    width: 100%;
  }
  &-desc {
    display: none;
    max-width: 600px;
    font-size: 10px;
    line-height: 16px;
    padding-top: 20px;
    font-family: Georgia;
    color: #6e6e6e;
  }

}

@media (max-width: 768px) {
  .portfoliowork-content {
    width: calc(100% - 40px);
    flex-direction: column;
  }
  .portfoliowork-img {
      margin-top: 20px;
  }
}
  
@media (min-width: 1920px) {
  .portfoliowork-desc {
    font-size: 13px;
    line-height: 20px;
  }
}



</style>
